import React, { useState } from 'react';

const AdminProductForm = ({ initial = {}, onCancel, onSave }) => {
  const [name, setName] = useState(initial.name || '');
  const [price, setPrice] = useState(initial.price || '');
  const [description, setDescription] = useState(initial.description || '');
  const [image, setImage] = useState(initial.image || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      id: initial.id || `p_${Date.now()}`,
      name: name.trim() || 'Untitled',
      price: Number(price) || 0,
      description: description.trim(),
      image: image.trim(),
    };
    onSave(payload);
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="mb-2">
        <label className="form-label">Name</label>
        <input className="form-control" value={name} onChange={e => setName(e.target.value)} />
      </div>

      <div className="mb-2">
        <label className="form-label">Price</label>
        <input type="number" className="form-control" value={price} onChange={e => setPrice(e.target.value)} />
      </div>

      <div className="mb-2">
        <label className="form-label">Image URL</label>
        <input className="form-control" value={image} onChange={e => setImage(e.target.value)} />
      </div>

      <div className="mb-2">
        <label className="form-label">Description</label>
        <textarea className="form-control" rows={3} value={description} onChange={e => setDescription(e.target.value)} />
      </div>

      <div className="d-flex gap-2">
        <button className="btn btn-primary" type="submit">Save</button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
};

export default AdminProductForm;
